import { render, staticRenderFns } from "./NavbarMain.vue?vue&type=template&id=4a2972c7&scoped=true&"
import script from "./NavbarMain.vue?vue&type=script&lang=js&"
export * from "./NavbarMain.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMain.vue?vue&type=style&index=0&id=4a2972c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2972c7",
  null
  
)

export default component.exports